export const DEFAULT_CURRENCY = "USD";
